import type { ChangeEvent } from 'react';
import { useEffect } from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { AutocompleteStatesAndCities } from '@/components/partial/autocomplete-states-cities';
import { ProfileStepIds } from '@/models/recommendation';
import { BaseQuestion } from '@/packages/profile-quiz/components/questions/base-question';
import { useProfileQuiz } from '@/packages/profile-quiz/context/profile-quiz';
import type { QuestionProps } from '@/packages/profile-quiz/context/profile-quiz/types';
import { ProfileFields } from '@/packages/profile-quiz/context/profile-quiz/types';

export const LocationInfoStep = (_props: QuestionProps) => {
  const { answers, setQuizAnswer, setCurrentStepValid } = useProfileQuiz();

  useEffect(() => {
    const hasAddress = Boolean(answers.address_state && answers.address_city);
    const isNonResident = Boolean(answers.non_resident);

    setCurrentStepValid(hasAddress || isNonResident);
  }, [
    answers.address_state,
    answers.address_city,
    answers.non_resident,
    setCurrentStepValid,
  ]);

  const onStateAndCityChange = (state: string, city: string) => {
    setQuizAnswer(ProfileFields.AddressState, state);
    setQuizAnswer(ProfileFields.AddressCity, city);
  };

  const handleNonResidentChange = (e: ChangeEvent<HTMLInputElement>) => {
    onStateAndCityChange('', '');
    setQuizAnswer(ProfileFields.NonResident, e.target.checked);
  };

  return (
    <BaseQuestion
      questionTitle="📍 Em qual estado e cidade você mora?"
      questionId={ProfileStepIds.LocationInfo}
      processedResponseText="Legal, já anotei sua localização! Isso ajuda a deixar nossas recomendações mais relevantes pra onde você está."
    >
      <AutocompleteStatesAndCities
        initialState={answers.address_state || ''}
        initialCity={answers.address_city || ''}
        onStateAndCityChange={onStateAndCityChange}
        direction="column"
        disabled={!!answers.non_resident}
      />
      <FormControlLabel
        control={
          <Checkbox
            onChange={handleNonResidentChange}
            checked={!!answers.non_resident}
          />
        }
        label={<Typography>Não moro no Brasil</Typography>}
      />
    </BaseQuestion>
  );
};
